import { render, staticRenderFns } from "./RequestDemo.vue?vue&type=template&id=ccbcfa0a&scoped=true"
import script from "./RequestDemo.vue?vue&type=script&lang=js"
export * from "./RequestDemo.vue?vue&type=script&lang=js"
import style0 from "./RequestDemo.vue?vue&type=style&index=0&id=ccbcfa0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbcfa0a",
  null
  
)

export default component.exports